module.exports = __webpack_public_path__ + "img/earth.eea957a8.png";